
import { Component, Vue, Prop } from 'vue-property-decorator'
import MediaLibrary from '@/components/MediaLibrary.vue'

@Component({ components: { MediaLibrary } })
export default class Media extends Vue {
  @Prop({ default: '/' }) folderPath!: string
}
